import React from 'react';
import {useTranslation} from 'react-i18next'

import GenericContentPage from '../common/GenericContentPage';
import ContentTranslation from '../statichtml/PrivacyPolicy'
import i18n from '../i18n';

const PrivacyPolicy = () => {
    const {t} = useTranslation();

    return <GenericContentPage
        headTitle={
            t('PrivacyPolicy.page-head-title')
        }
        title={
            t('PrivacyPolicy.privacy-policy')
        }
    >
        {(() => {
            if (ContentTranslation[i18n.language]) {
                return <div dangerouslySetInnerHTML={{__html: ContentTranslation[i18n.language] }} />
            } else if (ContentTranslation['en']) {
                return <div dangerouslySetInnerHTML={{__html: ContentTranslation['en'] }} />
            }
        })()}
    </GenericContentPage>
}

export default PrivacyPolicy;
